import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type UpdateUserSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateUserSettingsInputs;
}>;

export type UpdateUserSettingsMutation = {
  __typename?: 'Mutation';
  updateUserSettings: {
    __typename?: 'UpdateUserSettingsResponse';
    success: boolean;
    code: string;
    message: string;
    settings?: {
      __typename?: 'UserSettings';
      displayTTSVersionSelector?: boolean | null;
      defaultTTSVersion?: Types.TtsVersionSelectOption | null;
      globalAudioFileFormatSelected?: boolean | null;
      globalAudioFileFormat?: Types.AudioFileFormat | null;
      includeClipScriptFormats?: Array<Types.ScriptFormat> | null;
      doNotShowClipDeletionConfirmationModal?: boolean | null;
      doNotShowClipPreviewDeletionConfirmationModal?: boolean | null;
      doNotShowNavigationConfirmationModal?: boolean | null;
      doNotShowDeleteTeamReplacementConfirmationModal?: boolean | null;
      globalAudioPlaybackSetting?: Types.AudioPlaybackSetting | null;
    } | null;
  };
};

export type UpdateTeamSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateTeamSettingsInputs;
}>;

export type UpdateTeamSettingsMutation = {
  __typename?: 'Mutation';
  updateTeamSettings: {
    __typename?: 'UpdateTeamSettingsResponse';
    success: boolean;
    code: string;
    message: string;
    settings?: { __typename?: 'TeamSettings'; llmFeaturesEnabled: boolean } | null;
  };
};

export type UserSettingsFragment = {
  __typename?: 'User';
  settings: {
    __typename?: 'UserSettings';
    displayTTSVersionSelector?: boolean | null;
    defaultTTSVersion?: Types.TtsVersionSelectOption | null;
    globalAudioFileFormatSelected?: boolean | null;
    globalAudioFileFormat?: Types.AudioFileFormat | null;
    includeClipScriptFormats?: Array<Types.ScriptFormat> | null;
    doNotShowClipDeletionConfirmationModal?: boolean | null;
    doNotShowClipPreviewDeletionConfirmationModal?: boolean | null;
    doNotShowNavigationConfirmationModal?: boolean | null;
    doNotShowDeleteTeamReplacementConfirmationModal?: boolean | null;
    globalAudioPlaybackSetting?: Types.AudioPlaybackSetting | null;
  };
};

export const UserSettingsFragmentDoc = gql`
  fragment UserSettingsFragment on User {
    settings {
      displayTTSVersionSelector
      defaultTTSVersion
      globalAudioFileFormatSelected
      globalAudioFileFormat
      includeClipScriptFormats
      doNotShowClipDeletionConfirmationModal
      doNotShowClipPreviewDeletionConfirmationModal
      doNotShowNavigationConfirmationModal
      doNotShowDeleteTeamReplacementConfirmationModal
      globalAudioPlaybackSetting
    }
  }
`;
export const UpdateUserSettingsMutationDocument = gql`
  mutation updateUserSettingsMutation($input: UpdateUserSettingsInputs!) {
    updateUserSettings(inputs: $input) {
      success
      code
      message
      settings {
        displayTTSVersionSelector
        defaultTTSVersion
        globalAudioFileFormatSelected
        globalAudioFileFormat
        includeClipScriptFormats
        doNotShowClipDeletionConfirmationModal
        doNotShowClipPreviewDeletionConfirmationModal
        doNotShowNavigationConfirmationModal
        doNotShowDeleteTeamReplacementConfirmationModal
        globalAudioPlaybackSetting
      }
    }
  }
`;
export type UpdateUserSettingsMutationMutationFn = Apollo.MutationFunction<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >(UpdateUserSettingsMutationDocument, options);
}
export type UpdateUserSettingsMutationHookResult = ReturnType<
  typeof useUpdateUserSettingsMutation
>;
export type UpdateUserSettingsMutationMutationResult =
  Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;
export const UpdateTeamSettingsMutationDocument = gql`
  mutation updateTeamSettingsMutation($input: UpdateTeamSettingsInputs!) {
    updateTeamSettings(inputs: $input) {
      success
      code
      message
      settings {
        llmFeaturesEnabled
      }
    }
  }
`;
export type UpdateTeamSettingsMutationMutationFn = Apollo.MutationFunction<
  UpdateTeamSettingsMutation,
  UpdateTeamSettingsMutationVariables
>;

/**
 * __useUpdateTeamSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamSettingsMutation, { data, loading, error }] = useUpdateTeamSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamSettingsMutation,
    UpdateTeamSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTeamSettingsMutation,
    UpdateTeamSettingsMutationVariables
  >(UpdateTeamSettingsMutationDocument, options);
}
export type UpdateTeamSettingsMutationHookResult = ReturnType<
  typeof useUpdateTeamSettingsMutation
>;
export type UpdateTeamSettingsMutationMutationResult =
  Apollo.MutationResult<UpdateTeamSettingsMutation>;
export type UpdateTeamSettingsMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamSettingsMutation,
  UpdateTeamSettingsMutationVariables
>;
